import Icons from '@shared/components/core/images/Icons';
import { ActionWrapper, Content, EmptyContent, ListingCard } from '@shared/components/core/listing/CommonListingStyles';
import { CardTitleCentered } from '@shared/components/core/text/CardTypography';
import { BodySmall, SubtitleText } from '@shared/components/core/text/Typography';
import { useTranslation } from 'react-i18next';

export interface IAssociatedProgramsListingProps {
    programNames: string[];
    profileName: string;
    showDescription?: boolean;
}

function AssociatedProgramsListing({
    programNames,
    profileName,
    showDescription = true,
}: IAssociatedProgramsListingProps) {
    const { t } = useTranslation();
    return (
        <ListingCard>
            {programNames.length > 0 ? (
                <>
                    <CardTitleCentered>
                        {t('common:profile.autoProfileSwitching.associatedPrograms.title', '', {
                            profileName: profileName,
                        })}
                    </CardTitleCentered>
                    {showDescription && (
                        <BodySmall>
                            {t('common:profile.autoProfileSwitching.associatedPrograms.description.short')}
                        </BodySmall>
                    )}
                    <SubtitleText>
                        {t(
                            'common:profile.autoProfileSwitching.associatedPrograms.when',
                            `Cephable will automatically switch my profile to ${profileName} when I use...`,
                            { profileName: profileName }
                        )}
                    </SubtitleText>
                    {programNames.map((name, i) => {
                        if (name === '') {
                            return null;
                        }
                        return (
                            <ActionWrapper as="span" key={`associated_program_${i}`}>
                                <Content as="span">
                                    <Icons
                                        name="virtualApps"
                                        size={24}
                                        ariaLabel={t('common:profile.autoProfileSwitching.associatedPrograms.title')}
                                    />
                                    <p>{name}</p>
                                </Content>
                            </ActionWrapper>
                        );
                    })}
                </>
            ) : (
                <EmptyContent>{t('common:profile.autoProfileSwitching.associatedPrograms.emptySearch')}</EmptyContent>
            )}
        </ListingCard>
    );
}

export default AssociatedProgramsListing;
